import $ from 'jquery';
import { Component } from 'react';

class TeamComparison extends Component {
  constructor() {
    super();
    this.tooltipId = 'team-helper-text';
  }

  componentDidMount() {
    $(`#${this.tooltipId}`).tooltip({ html: true, title: this.props.help });
  }

  render() {
    let headlineStyle = {
      fontSize: this.props.value ? 25 : null,
    };
    return (
      <div className="status-block">
        <div
          className="status-block__status spec-team-comparison"
          style={headlineStyle}
        >
          {this.props.value || 'N/A'}
        </div>
        <div className="status-block__title">
          {this.props.label}{' '}
          <i
            id={this.tooltipId}
            data-toggle="tooltip"
            className="fa fa-question-circle"
          />
        </div>
      </div>
    );
  }
}

export default TeamComparison;
